import React, { type ForwardedRef, type PropsWithChildren } from "react";

import clsx from "clsx";

import { type TableTreeColumn } from "@devexpress/dx-react-grid-bootstrap4";

import { useShowTableSelectColumn } from "../../../hooks/use-show-table-select-column";
import { SELECTION_COLUMN_WIDTH } from "../constants";

interface Props extends PropsWithChildren<TableTreeColumn.CellProps> {
  forwardedRef?: ForwardedRef<HTMLTableCellElement>;
}

export const TableTreeColumnCell = ({
  column,
  children,
  tableRow,
  tableColumn,
  row,
  forwardedRef,
  ...restProps
}: Props) => {
  const [showSelectColumn] = useShowTableSelectColumn();
  const leftOffset = showSelectColumn ? SELECTION_COLUMN_WIDTH : 0;
  return (
    <td
      ref={forwardedRef}
      {...restProps}
      className="border-right dx-g-bs4-fixed-cell position-sticky cell-clickable group/row z-2"
      style={{ left: `${leftOffset}px` }}
    >
      <div
        className={clsx("flex h-full px-2", {
          // TODO: update
          "ml-8": !true,
        })}
      >
        {children}
      </div>
    </td>
  );
};
